import { createUseQueryHook } from 'hooks/createUseQueryHook';

export const usePersonTripHolidays = (options: { isEnabled: boolean }) => {
    const { isEnabled } = options;

    return createUseQueryHook('person_trip_get_holidays', { enabled: isEnabled, keepPreviousData: true });
};
